/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import Userbanner from '../../../../components/elements/Userbanner';
import { getAsync } from '../../../../components/helper/axiosHelper';
import { handleFileDownload } from '../../../../libs';
import { DetailAccordion } from '../../../external/service/sd/DetailAccordion';
// import './sDProjectApproval.scss';

const ServiceForDeadView = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [apiData, setApiData] = useState([]);
  const [eP_ID, setEP_ID] = useState([]);
  const [eP_DeadCertificateDoc, setEP_DeadCertificateDoc] = useState([]);
  const [eP_ApprovalLetterDoc, setEP_ApprovalLetterDoc] = useState([]);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [maNotes, setMaNotes] = useState('');
  const [selectedEP_IDImageData, setSelectedEP_IDImageData] = useState(null);
  const [selectedDeadCertificateImageData, setSelectedDeadCertificateImageData] = useState(null);
  const [selectedApprovalLetterImageData, setSelectedApprovalLetterImageData] = useState(null);
  const [deadCertificate, setDeadCertificate] = useState('');
  const [approvalLetter, setApprovalLetter] = useState('');
  const [mediaData, setMediaData] = useState([]);
  const [limitRequest, setLimitRequest] = useState(true);
  const [isLoad, setIsLoad] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token) {
      window.location.href = '/donorLogin';
    }
  };

  useEffect(() => {
    isLogin();
    getData();
  }, []);

  const getData = async () => {
    const startTime = performance.now();
    try {
      // setIsLoad(true);
      const response = await getAsync('ServiceDead/GetSDByIDAsync/', { id: id });
      // if (response) {
      //   setIsLoad(false);
      // }
      if (response.statusCode === 200) {
        const result = response?.data[0];
        setMediaData(result?.archiveMediaModelList);
        setEP_ID(result?.epUserID);
        setApiData(result);
      } else {
        toast.error(t('Something went wrong, Please try again!'));
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    } finally {
      const endTime = performance.now();
      const responseTimeInSeconds = (endTime - startTime) / 1000;
    }
  };

  const openModal = (e, data) => {
    e.preventDefault();
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  const handleDocLoad = async (e) => {
    e.preventDefault();
    await getData();
    setLimitRequest(false);
  };

  const handleEP_IdDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${base64Data}`; // Update MIME type based on your image format
      link.download = fileName || 'image.png'; // Set the desired file name or fallback to 'image.png'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleEP_DeadCertificateDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'image/*' });
      const fileUrl = URL.createObjectURL(fileBlob);
      const img = document.createElement('img');
      img.src = fileUrl;
      document.body.appendChild(img);
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.href = fileUrl;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      document.body.removeChild(img);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleEP_ApprovalLetterDownload = async (e, base64Data, fileName) => {
    try {
      e.preventDefault();

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'image/*' });
      const fileUrl = URL.createObjectURL(fileBlob);
      const img = document.createElement('img');
      img.src = fileUrl;
      document.body.appendChild(img);
      const downloadLink = document.createElement('a');
      downloadLink.download = fileName;
      downloadLink.href = fileUrl;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      document.body.removeChild(img);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <div className="py-5 lg:py-10 ">
      <Userbanner />
      {isLoad ? (
        <LoadingAnimation />
      ) : (
        <div className="container-fluid">
          <div className="col-lg-12 ">
            <form>
              <div className="card">
                <div className="card-header">
                  <h1 className="font-bold sm:text-2xl text-center  text-xl text-customgreen">
                    {t('Service For Dead View')}{' '}
                  </h1>
                </div>
                <div className="card-body">
                  <div className="row ">
                    <div className="col-lg-12">
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Details')}</h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                          <div className="row">
                            <div className="col-lg-6 my-2">
                              <div className="form-group">
                                <label className="text-gray-700 text-pretty text-sm" htmlFor="deadName">
                                  {t('Name of Dead Person')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  name="deadName"
                                  value={apiData.deadName}
                                  type="text"
                                  disabled
                                  style={{


                                    cursor: 'no-drop',
                                  }}
                                  className=" w-full border border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 my-2">
                              <div className="form-group">
                                <label>
                                  {t('Project Name')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.newProjectName}
                                  disabled
                                  style={{


                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                  minLength="1"
                                  maxLength="100"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 my-2">
                              <div className="form-group">
                                <label>
                                  {t('Relationship')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={t(`${apiData?.relationName}`)}
                                  disabled
                                  style={{


                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 my-2">
                              <div className="form-group">
                                <label>
                                  {t('Applicant Mobile')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.applicantMobile}
                                  disabled
                                  style={{


                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                  minLength="1"
                                  maxLength="20"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 my-2">
                              <div className="form-group">
                                <label>
                                  {t('Applicant Name')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.applicantName}
                                  disabled
                                  style={{


                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      <br />

                      <DetailAccordion
                        limitRequest={limitRequest}
                        handleDocLoad={handleDocLoad}
                        mediaData={mediaData}
                        handleFileDownload={handleFileDownload}
                        eP_ID={eP_ID}
                        title={'Document Details'}
                      />
                      <br />

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>
                                {t('Managed Project Notes')} <span className="errmsg">*</span>
                              </label>
                              <textarea
                                style={{ height: '100px' }}
                                value={apiData?.maNotes}
                                onChange={(e) => setMaNotes(e.target.value)}
                                className=" w-full border border-gray-300 cursor-not-allowed  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                minLength="1"
                                maxLength="500"
                                disabled
                              />
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      <br />
                      {/*
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Confirmation</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography></Typography>
                        <h3>Enter Password To Confirm</h3>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>
                              Password<span className="errmsg">*</span>
                            </label>
                            <input
                              value={password}
                              type="password"
                              onChange={(e) => setPassword(e.target.value)}
                               className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block"

                              minLength="1"
                              maxLength="50"
                            />
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion> */}
                    </div>
                  </div>
                </div>
                <div className="card-footer  flex">
                  <Link to={'/ServiceForDeadList'}>
                    <button
                      type="button"
                      className="text-white bg-customgreen hover:bg-hovergreen   rounded-full  px-4 py-2 me-2 text-center"
                    >
                      {t('Back')}
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceForDeadView;
